import { configureStore } from '@reduxjs/toolkit';
import detailsReducer from './redux/detailsSlice';

export const store = configureStore({
  reducer: {
    details: detailsReducer,
  },
});
